import React,{useState,useEffect,useRef}from 'react';
import{useParams}from 'react-router-dom';
import axios from 'axios';
const api=axios.create({baseURL:'/api'});

function InfoRow({label,value}){
  if(value===null||value===undefined||value==='')return null;
  return(<div className="flex justify-between py-1.5 border-b border-gray-50 last:border-0"><span className="text-sm text-gray-500">{label}</span><span className="text-sm font-semibold text-gray-800 text-right ml-4">{String(value)}</span></div>);
}

function Section({title,color='#2D6A9F',children}){
  return(<div className="bg-white rounded-xl border border-gray-200 overflow-hidden mb-3"><div style={{background:color}} className="px-4 py-2"><h3 className="text-white font-bold text-xs uppercase tracking-wide">{title}</h3></div><div className="px-4 py-2">{children}</div></div>);
}

function EqRow({label,value}){
  if(value===null||value===undefined)return null;
  const yes=value===true||value===1||value==='true'||value==='t';
  const no=value===false||value===0||value==='false'||value==='f';
  if(yes||no){
    return(<div className="flex justify-between py-1.5 border-b border-gray-50 last:border-0"><span className="text-sm text-gray-500">{label}</span><span className={`text-sm font-bold ${yes?'text-green-600':'text-red-500'}`}>{yes?'TAK':'NIE'}</span></div>);
  }
  return <InfoRow label={label} value={value}/>;
}

export default function SignProtocol(){
  const{token}=useParams();
  const canvasRef=useRef(null);
  const[data,setData]=useState(null);
  const[loading,setLoading]=useState(true);
  const[error,setError]=useState(null);
  const[signing,setSigning]=useState(false);
  const[signed,setSigned]=useState(false);
  const[isEmpty,setIsEmpty]=useState(true);
  const[drawing,setDrawing]=useState(false);
  const lastPos=useRef(null);

  useEffect(()=>{
    api.get('/signatures/token/'+token)
      .then(r=>{setData(r.data);if(r.data.status==='signed')setSigned(true);setLoading(false);})
      .catch(e=>{setError(e.response?.data?.error||'Nie znaleziono protokolu');setLoading(false);});
  },[token]);

  useEffect(()=>{
    if(!data||signed)return;
    const canvas=canvasRef.current;if(!canvas)return;
    const ctx=canvas.getContext('2d');
    ctx.fillStyle='#ffffff';ctx.fillRect(0,0,canvas.width,canvas.height);
    ctx.strokeStyle='#1E3A5F';ctx.lineWidth=2.5;ctx.lineCap='round';ctx.lineJoin='round';
  },[data,signed]);

  const getPos=(e,canvas)=>{
    const rect=canvas.getBoundingClientRect();
    const sx=canvas.width/rect.width,sy=canvas.height/rect.height;
    if(e.touches)return{x:(e.touches[0].clientX-rect.left)*sx,y:(e.touches[0].clientY-rect.top)*sy};
    return{x:(e.clientX-rect.left)*sx,y:(e.clientY-rect.top)*sy};
  };
  const startDraw=e=>{e.preventDefault();setDrawing(true);setIsEmpty(false);lastPos.current=getPos(e,canvasRef.current);};
  const draw=e=>{
    e.preventDefault();if(!drawing)return;
    const canvas=canvasRef.current,ctx=canvas.getContext('2d'),pos=getPos(e,canvas);
    ctx.beginPath();ctx.moveTo(lastPos.current.x,lastPos.current.y);ctx.lineTo(pos.x,pos.y);ctx.stroke();
    lastPos.current=pos;
  };
  const endDraw=e=>{e.preventDefault();setDrawing(false);lastPos.current=null;};
  const clearCanvas=()=>{
    const canvas=canvasRef.current,ctx=canvas.getContext('2d');
    ctx.fillStyle='#ffffff';ctx.fillRect(0,0,canvas.width,canvas.height);setIsEmpty(true);
  };
  const submitSignature=async()=>{
    if(isEmpty)return;setSigning(true);
    try{
      await api.post('/signatures/token/'+token+'/sign',{signature_data:canvasRef.current.toDataURL('image/png')});
      setSigned(true);
    }catch(e){alert('Blad: '+(e.response?.data?.error||e.message));}
    finally{setSigning(false);}
  };

  if(loading)return<div className="min-h-screen bg-gray-50 flex items-center justify-center"><div className="text-center text-gray-400"><div className="text-4xl mb-3">⏳</div><p>Ladowanie...</p></div></div>;
  if(error)return<div className="min-h-screen bg-gray-50 flex items-center justify-center p-4"><div className="bg-white rounded-2xl shadow-lg p-8 max-w-sm w-full text-center"><div className="text-5xl mb-4">❌</div><h2 className="text-lg font-bold mb-2">Blad</h2><p className="text-gray-500 text-sm">{error}</p></div></div>;
  if(signed)return(
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-sm w-full text-center">
        <div className="text-6xl mb-4">✅</div>
        <h2 className="text-xl font-bold text-green-700 mb-2">Protokol podpisany</h2>
        <p className="text-gray-500 text-sm mb-4">Dziekujemy! Protokol {data?.type==='handover'?'przekazania':'zdania'} pojazdu {data?.vehicle?.plate||''} zostal podpisany.</p>
        {data?.signed_at&&<p className="text-xs text-gray-400">Data: {new Date(data.signed_at).toLocaleString('pl-PL')}</p>}
        <div className="mt-6 p-3 bg-green-50 rounded-xl text-xs text-green-700">Mozesz zamknac te strone.</div>
      </div>
    </div>
  );

  const{driver,type,vehicle}=data;
  const pd=data.protocol_data||{};
  const v=vehicle||{};

  const stdEq=[
    {key:'eq_extinguisher',label:'Gasnica'},
    {key:'eq_triangle',label:'Trojkat ostrzegawczy'},
    {key:'eq_spare_wheel',label:'Kolo zapasowe'},
    {key:'eq_mats_rubber',label:'Maty gumowe'},
    {key:'eq_mats_velour',label:'Maty welurowe'},
    {key:'eq_seat_covers',label:'Pokrowce na siedzenia'},
    {key:'eq_phone_holder',label:'Uchwyt telefonu'},
    {key:'eq_beacon',label:'Kogut / sygnal swietlny'},
  ];

  const eL=(t)=>({petrol:'Benzyna',diesel:'Diesel',electric:'Elektryczny',hybrid:'Hybryda',lpg:'LPG'})[t]||t||'';
  const engineStr=[v.engine_type?eL(v.engine_type):null,v.engine_capacity?v.engine_capacity+' L':null].filter(Boolean).join(' / ')||null;
  const tireStr=[v.tire_brand,v.tire_size,v.tire_type==='alloy'?'Alu':v.tire_type==='steel'?'Stalowe':null].filter(Boolean).join(', ')||null;
  const batStr=[v.battery_brand,v.battery_capacity?v.battery_capacity+' Ah':null].filter(Boolean).join(', ')||null;
  const mileage=pd.mileage_override||v.mileage;
  const faults=pd.faults||[];
  let sn=1;

  return(
    <div className="min-h-screen bg-gray-50">
      <div className="bg-[#1E3A5F] text-white px-4 py-3 text-center">
        <p className="text-xs opacity-70">CAR Fleet System</p>
        <h1 className="text-base font-bold">{type==='handover'?'Protokol przekazania pojazdu':'Protokol zdania pojazdu'}</h1>
      </div>
      <div className="max-w-lg mx-auto p-4">

        <Section title={`${sn++}. Dane pojazdu`}>
          <InfoRow label="Marka / Model" value={v.brand&&v.model?v.brand+' '+v.model:null}/>
          <InfoRow label="Nr rejestracyjny" value={v.plate}/>
          <InfoRow label="VIN" value={v.vin}/>
          <InfoRow label="Rok produkcji" value={v.year}/>
          <InfoRow label="Kolor" value={v.color}/>
          <InfoRow label="Silnik / Pojemnosc" value={engineStr}/>
          <InfoRow label="Przebieg (km)" value={mileage?Number(mileage).toLocaleString('pl-PL')+' km':null}/>
          <InfoRow label="Oddzial" value={[v.branch_name,v.region_name].filter(Boolean).join(' / ')||null}/>
        </Section>

        <Section title={`${sn++}. ${type==='handover'?'Przejmujacy kierowca':'Zdajacy kierowca'}`}>
          <InfoRow label="Imie i nazwisko" value={driver?driver.first_name+' '+driver.last_name:null}/>
          <InfoRow label="Nr kierowcy" value={driver?.driver_number}/>
          <InfoRow label="Email" value={driver?.email}/>
          <InfoRow label="Telefon" value={driver?.phone}/>
        </Section>

        <Section title={`${sn++}. Wyposazenie standardowe`}>
          {stdEq.map(({key,label})=>(<EqRow key={key} label={label} value={v[key]}/>))}
          {v.key_count!=null&&<InfoRow label="Liczba kluzykow" value={v.key_count+' szt.'}/>}
          {tireStr&&<InfoRow label="Ogumienie" value={tireStr}/>}
          {batStr&&<InfoRow label="Akumulator" value={batStr}/>}
          {v.equipment_notes&&<InfoRow label="Uwagi o wyposazeniu" value={v.equipment_notes}/>}
        </Section>

        <Section title={`${sn++}. Stan techniczny`}>
          {faults.length>0?(
            <div>
              <p className="text-xs text-orange-600 font-semibold mb-2">Aktywne usterki: {faults.length}</p>
              {faults.map((f,i)=><div key={i} className="text-sm text-gray-700 py-1 border-b border-gray-50">{i+1}. {f.description||f.title||'Usterka'}</div>)}
            </div>
          ):(
            <p className="text-sm text-green-600 font-semibold py-1">Brak aktywnych usterek - pojazd sprawny</p>
          )}
        </Section>

        {(pd.handover_place||pd.handover_time)&&(
          <Section title={`${sn++}. Miejsce i data`}>
            <InfoRow label="Miejscowosc" value={pd.handover_place}/>
            <InfoRow label="Data" value={pd.handover_date?new Date(pd.handover_date).toLocaleDateString('pl-PL'):null}/>
            <InfoRow label="Godzina" value={pd.handover_time}/>
            {pd.return_reason&&<InfoRow label="Powod zdania" value={pd.return_reason}/>}
          </Section>
        )}

        {pd.handover_notes&&(
          <Section title={`${sn++}. Uwagi`}>
            <p className="text-sm text-gray-700 py-1">{pd.handover_notes}</p>
          </Section>
        )}

        {pd.photo_urls&&pd.photo_urls.length>0&&(
          <Section title={`${sn++}. Dokumentacja fotograficzna`}>
            <div className="grid grid-cols-2 gap-2 pt-1">
              {pd.photo_urls.filter(Boolean).slice(0,4).map((url,i)=>(
                <img key={i} src={url} alt={`Zdjecie ${i+1}`}
                  className="w-full rounded-lg border border-gray-200 object-cover"
                  style={{maxHeight:'160px'}}
                  onError={e=>{e.target.style.display='none';}}
                />
              ))}
            </div>
          </Section>
        )}

        <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 text-sm text-blue-800 mb-3">
          <p className="font-semibold mb-1">Oswiadczenie</p>
          <p>Potwierdzam {type==='handover'?'przejecie':'zdanie'} pojazdu <strong>{v.plate}</strong> zgodnie z warunkami powyzszego protokolu. Zapoznalem/am sie z jego trescia i potwierdzam jej zgodnosc ze stanem faktycznym.</p>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 p-4 mb-3">
          <div className="flex items-center justify-between mb-2">
            <h3 className="font-semibold text-gray-700 text-sm">Podpis elektroniczny</h3>
            <button onClick={clearCanvas} className="text-xs text-gray-400 hover:text-red-500 border border-gray-200 px-2 py-1 rounded-lg">Wyczysc</button>
          </div>
          <div className="border-2 border-dashed border-gray-300 rounded-xl overflow-hidden">
            <canvas ref={canvasRef} width={600} height={180} className="w-full touch-none cursor-crosshair" style={{display:'block'}}
              onMouseDown={startDraw} onMouseMove={draw} onMouseUp={endDraw} onMouseLeave={endDraw}
              onTouchStart={startDraw} onTouchMove={draw} onTouchEnd={endDraw}/>
          </div>
          {isEmpty&&<p className="text-xs text-gray-400 text-center mt-1">Narysuj podpis powyzej palcem lub mysza</p>}
        </div>

        <button onClick={submitSignature} disabled={isEmpty||signing}
          className="w-full py-4 rounded-xl font-bold text-white text-base transition disabled:opacity-50 bg-green-600 hover:bg-green-700 mb-4">
          {signing?'Zapisywanie...':'Podpisz protokol'}
        </button>

        <p className="text-xs text-gray-400 text-center pb-6">
          Link wazny do: {new Date(data?.expires_at).toLocaleDateString('pl-PL')} • Podpis elektroniczny ma moc prawna zgodnie z rozp. eIDAS.
        </p>
      </div>
    </div>
  );
}
